export default "__VITE_ASSET__CKcWkfhX__"